<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import CreateRule from "./CreateRule.vue";
import EditRule from "./EditRule.vue";

const route = useRoute();

const showCreateRule = computed(() => {
  return route.name === "DashboardRulesCreate";
});

const showEditRule = computed(() => {
  return (
    !showCreateRule.value &&
    (route.name === "DashboardRules" || route.name === "DashboardRulesEdit")
  );
});

console.log("DASHBOARD RULES");
</script>
<template>
  <div class="ml-4" style="width: 100%">
    <div class="px-4" style="width: 100%">
      <CreateRule v-if="showCreateRule" :route="route"></CreateRule>
      <EditRule v-if="showEditRule" :route="route"></EditRule>
    </div>
  </div>
</template>
<style scoped></style>
